<script>
import EventBus from './../EventBus.js'
import get from 'lodash/get'

import Countdown from './../components/HomeCountdown.vue'

export default {
  name: 'home',
  props: [],
  components: {
    Countdown,
  },
  data() {
    return {
      currentCase: 1,
      totalCase: 0,
      thumbnailWidth: 0,
      caseThumnailTransforming: false,
      caseSliderOption: {
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          change: function () {
            this.caseChange()
          },
        }
      },
      totalPicture: 0,
      currentPicture: 0,
      photoSliderOption: {
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          change: function () {
            this.pictureChange()
          },
        }
      },
      vw: 0,
      vh: 0,
    }
  },
  mounted() {
    this.handleResize()
    this.totalPicture = this.$refs.photoSwiper.$el.querySelectorAll('.picture').length
  	this.totalCase = this.caseRef.querySelectorAll('.thumbnail').length
  	this.$refs.case.querySelector('.thumbnail-container').addEventListener("transitionend", this.caseThumbnailTransitionHandler)
    window.addEventListener('resize', this.handleResize)

  },
  computed: {
  	thumbnailWrapperW() {
  		return `${this.totalCase * 100}%`
  	},
    caseRef() {
      return this.vw < 960 ? get(this, '$refs.case') : get(this, '$refs.caseDesktop')
    },
    swiperRef() {
      return this.vw < 960 ? this.$refs['caseSwiper'] : this.$refs['caseSwiperDesktop']
    },
  },
  methods: {
  	prevCase() {
  		if (this.currentCase > 1) {
  			this.currentCase -= 1
        this.swiperRef.swiper.slideTo(this.currentCase  - 1)
  		}
  	},
  	nextCase() {
  		if (this.currentCase < this.totalCase) {
  			this.currentCase += 1
        this.swiperRef.swiper.slideTo(this.currentCase  - 1)
  		}
  	},
  	caseThumbnailTransitionHandler() {
  		this.caseThumnailTransforming = false
  	},
    pictureChange() {
      console.log('pictureChange')
      this.currentPicture = this.$refs.photoSwiper.swiper.activeIndex
    },
    caseChange() {
      console.log('caseChange', this.swiperRef.swiper)
      this.currentCase = this.swiperRef.swiper.activeIndex + 1
    },
    gotoPicture(num) {
      this.$refs.photoSwiper.swiper.slideTo(num)
      this.currentPicture = num
    },
    handleResize() {
        this.updateViewport()
        if (this.swiperRef.swiper.activeIndex !== this.currentCase - 1)  this.swiperRef.swiper.slideTo(this.currentCase - 1)
    },
    updateViewport() {
        this.vw = window.innerWidth
        this.vh = window.innerHeight
    },
  },
}
</script>
